var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7908 19.5V15C14.7908 14.8011 14.7118 14.6103 14.5711 14.4697C14.4304 14.329 14.2397 14.25 14.0408 14.25H11.0408C10.8419 14.25 10.6511 14.329 10.5104 14.4697C10.3698 14.6103 10.2908 14.8011 10.2908 15V19.5C10.2908 19.6989 10.2118 19.8897 10.0711 20.0303C9.93045 20.171 9.73968 20.25 9.54077 20.25H5.04077C4.84186 20.25 4.65109 20.171 4.51044 20.0303C4.36979 19.8897 4.29077 19.6989 4.29077 19.5V10.8319C4.29078 10.7274 4.31264 10.624 4.35494 10.5284C4.39723 10.4328 4.45904 10.3472 4.5364 10.2769L12.0364 3.195C12.1745 3.06931 12.3545 2.99965 12.5412 2.99965C12.728 2.99965 12.908 3.06931 13.0461 3.195L20.5461 10.2769C20.6234 10.3472 20.6852 10.4328 20.7275 10.5284C20.7698 10.624 20.7917 10.7274 20.7917 10.8319V19.5C20.7917 19.6989 20.7127 19.8897 20.572 20.0303C20.4314 20.171 20.2406 20.25 20.0417 20.25H15.5408C15.3419 20.25 15.1511 20.171 15.0104 20.0303C14.8698 19.8897 14.7908 19.6989 14.7908 19.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.540771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.98e73cfb791cc6221b2c8709feea23d1.svg";
export { ForwardRef as ReactComponent };